import { render, staticRenderFns } from "./NoResultArea.vue?vue&type=template&id=9b2894e2&"
import script from "./NoResultArea.vue?vue&type=script&lang=js&"
export * from "./NoResultArea.vue?vue&type=script&lang=js&"
import style0 from "./NoResultArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports